import {
    COUPON_CAMPAIGN_STATUS_ACTIVE,
    COUPON_CAMPAIGN_STATUS_DISMISSED,
    COUPON_CAMPAIGN_STATUS_DRAFT
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useStatusValuesCouponCampaign = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getStatusColor = (status: string) => {
        switch (status) {
            case COUPON_CAMPAIGN_STATUS_ACTIVE: return theme.palette.success.transparent;
            case COUPON_CAMPAIGN_STATUS_DISMISSED: return theme.palette.error.transparent;
            case COUPON_CAMPAIGN_STATUS_DRAFT: return theme.palette.warning.transparent;
        }
    };

    const getStatusLabel = (status: string) => {
        switch (status) {
            case COUPON_CAMPAIGN_STATUS_ACTIVE: return t('salesmarketing:coupon.statusValues.active');
            case COUPON_CAMPAIGN_STATUS_DISMISSED: return t('salesmarketing:coupon.statusValues.dismissed');
            case COUPON_CAMPAIGN_STATUS_DRAFT: return t('salesmarketing:coupon.statusValues.draft');
        }
    };

    return {
        getStatusColor,
        getStatusLabel
    }
}